document.addEventListener("DOMContentLoaded", () => {
    const gallery = document.getElementById("sections-gallery");
    const moreMenu = document.getElementById("more-menu");
    const dropdown = document.getElementById("more-dropdown");
    const GAP = 50;

    function updateSections() {
        const links = [...gallery.querySelectorAll(".section-link")];

        links.forEach(link => link.style.display = "");
        dropdown.innerHTML = "";

        const wrapperWidth = gallery.parentElement.offsetWidth;
        let totalWidth = 0;
        let overflowLinks = [];

        links.forEach(link => {
            const linkWidth = link.offsetWidth + GAP;
            if (totalWidth + linkWidth <= wrapperWidth) {
                totalWidth += linkWidth;
            } else {
                overflowLinks.push(link);
            }
        });

        if (overflowLinks.length > 0) {
            moreMenu.classList.remove("hide");

            totalWidth = 0;
            overflowLinks = [];

            links.forEach(link => {
                const linkWidth = link.offsetWidth + GAP;
                if (totalWidth + linkWidth + moreMenu.offsetWidth + GAP <= wrapperWidth) {
                    totalWidth += linkWidth;
                } else {
                    overflowLinks.push(link);
                }
            });

            overflowLinks.forEach(link => {
                link.style.display = "none";
                const clone = link.cloneNode(true);
                clone.style.display = "block";
                dropdown.appendChild(clone);
            });
        } else {
            moreMenu.classList.add("hide");
        }

        document.dispatchEvent(new CustomEvent("bc:sections-updated"));
    }

    if (gallery) {
        window.addEventListener("resize", updateSections);
        updateSections();
    }
});

function openSections() {
    if (phoneActive) {
        setTimeout(() => {
            showSideNavMenu('sideNavSections');
            openSideNav();
        }, 100);
    }
}
